module.exports = __webpack_public_path__ + "img/how-step-3.569fd92f.png";